import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../../lib/shared/validators";

export const cancelationRequestReasons = v.union(
  v.literal("payment_issue"),
  v.literal("product_issue"),
  v.literal("duplicated_data"),
  v.literal("product_not_received"),
  v.literal("client_request"),
  v.literal("other"),
);

export const statusCancelationRequest = v.union(
  v.literal("pending"),
  v.literal("completed"),
  v.literal("cancelled"),
  v.literal("cancelation_pending"),
);

export const validatorCancelationRequest = v.object({
  status: statusCancelationRequest,
  invoiceId: v.id("invoices"),
  requestedBy: v.id("users"),
  reason: cancelationRequestReasons,
  observations: v.string(),

  attachmentsIds: v.optional(v.array(v.id("storage"))),
  approvedDate: v.optional(v.number()),
  approvedBy: v.optional(v.id("users")),
  rejectionDate: v.optional(v.number()),
  rejectedBy: v.optional(v.id("users")),
  rejectionReason: v.optional(v.string()),
  internalControl,
});

export const invoices_cancelation_requests = defineTable(
  validatorCancelationRequest,
)
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_company_and_invoice", ["internalControl.companyId", "invoiceId"])
  .index("by_company_and_status", ["internalControl.companyId", "status"])
  .index("by_invoiceId", ["invoiceId"])
  .index("by_invoiceId_and_status", ["invoiceId", "status"])
  .index("by_status", ["status"])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ]);
